<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true" width="35%" :show-close="false" z-index="99999"
      :before-close="onCLose">
      <span class="close-icon" @click="onCLose"></span>
      <div class="center-info">
        <div class="info">
          <div class="info-title">您所在教学段</div>
          <div class="info-btns">
            <div v-for="(period, index) in periodTypeList" :key="index" class="info-btn"
              :class="{ selectBtn: periodId === period.id }" @click="select('period', period)">
              {{ period.name }}
            </div>
          </div>
        </div>
        <div class="info">
          <div class="info-title">您所在教的学科</div>
          <div class="info-btns">
            <div v-for="(subject, index) in subjectTypeList" :key="index" class="info-btn"
              :class="{ selectBtn: subjectId === subject.id }" @click="select('subject', subject)">
              {{ subject.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="sub-btn">
        <el-button type="primary" @click="confirm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getCommonInfo } from '@/api/common';
import { getUserInfo } from "@/api/user";
import { modUserInfo } from "@/api/user.js";
import { mapGetters } from "vuex";
export default {
  name: "DialogUpdataInfo",
  data() {
    return {
      periodTypeList: [],
      subjectTypeList: [],
      periodId: null,
      subjectId: null
    };
  },
  props: ["dialogVisible"],
  watch: {
    dialogVisible(newVal) {
      if (newVal) {
        this.gitCommonInfo();
        this.getUserInfo();
      } else {
        this.periodId = null;
        this.subjectId = null;
      }
    }
  },
  computed: {
    ...mapGetters(["isUserEditDialog"]),
    
  },
  mounted() {
    
  },
  methods: {
    gitCommonInfo() {
      getCommonInfo().then(res => {
      if (res.code === 200) {
        const { periodTypeList, subjectTypeList } = res.data;
        this.subjectTypeList = subjectTypeList;
        this.periodTypeList = periodTypeList;
      }
    });
    },
    getUserInfo() {
      getUserInfo().then((res) => {
        if (res.code === 200) {
          const { period, subject } = res.data;
          this.periodId = period;
          this.subjectId = subject;
        }
      });
    },
    select(type, item) {
      switch (type) {
        case 'period':
          this.periodId = item.id;
          break;
        case 'subject':
          this.subjectId = item.id;
          break;
      }
    },
    onCLose() {
      this.$emit("cloeseDialog");
    },
    confirm() {
      const params = {
        subject: this.subjectId,
        period: this.periodId,
      };
      modUserInfo(params).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "设置成功",
            type: "success",
          });
          this.$store.commit("user/SET_USERINFO", {
            data: { userInfo: { ...res.data } },
          });
          this.$emit("cloeseDialog");
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
  },
 
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
  border-radius: 10px !important;
  width: 690px !important;
  height: 500px !important;
  flex-shrink: 0;
  background: #fff;
}
::v-deep .el-dialog__body {
  padding: 0 20px;
}

.info {
    margin-top: 14px;
    &-title {
      color: #0F0F10;
      font-family: "PingFang SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-bottom: 13px;
    }
    &-btns {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 16px;
    }
    &-btn {
      width: 113px;
      height: 46px;
      flex-shrink: 0;
      color: #323233;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      border-radius: 10px;
      border: 1px solid #EAEAEA;;
      text-align: center;
      line-height: 46px;
      &:hover {
        cursor: pointer;
        color: #0D70ED;
        border: 1px solid #0D70ED;
      }
    }
  }
  .selectBtn {
    color: #0D70ED;
    border: 1px solid #0D70ED;
  }


.head {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 8px;
  height: 23px;
}

.headdiv {
  width: 23px;
  height: 23px;
  position: relative;
}

.headimg {
  position: absolute;
  top: 1px;
  width: 23px;
  height: 23px;
  border-radius: 23px;
  border: 2px solid #fff;
  background: url(<path-to-image>) lightgray 50% / cover no-repeat;
}

.headname {
  color: #0f0f10;
  font-family: "PingFang SC";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  /* 100% */
}

.duicontent {
  color: #0f0f10;
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.duiinput {
  margin-top: 14px;
  width: 460px;
  height: 46px;
  flex-shrink: 0;
  // border: solid 1px #EAEAEA;
  // border-radius: 5px;
}

.inputcontent {
  width: 100%;
  height: 100%;
  // border-radius: 5px;
  // border: solid 1px #EAEAEA;
}

.sub-btn {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
}

::v-deep .el-button--primary {
  width: 160px;
  height: 46px;
  flex-shrink: 0;
  border-radius: 8px;
  background: linear-gradient(153deg, #3774f3 -24.36%, #1a87f4 106.05%);
  cursor: pointer;
}
.close-icon {
  position: absolute;
  top: 19px;
  right: 19px;
  display: inline-block;
  cursor: pointer;
  width: 14px;
  height: 14px;
  background: url(../../../assets/images/invite/clone.png) no-repeat center center;
  background-size: cover;
}
</style>
